(function () {
  'use strict';

  const BIKE_NAMES = {
    fit_ultra_bee:       'Ultra Bee',
    fit_light_bee_x:     'Light Bee X',
    fit_ventus_one:      'Ventus One',
    fit_79bike:          '79Bike',
    fit_talaria_xxx:     'Talaria XXX',
    fit_talaria_mx3_mx4: 'Talaria MX3/MX4',
    fit_talaria_mx5:     'Talaria MX5',
    fit_eride_pro_20:    'ERide Pro 2.0',
    fit_eride_pro_30:    'ERide Pro 3.0',
    fit_eride_pro_sr:    'ERide Pro SR',
    fit_tuttio:          'Tuttio',
    fit_super_73:        'Super 73',
    fit_ridstar:         'Ridstar',
    fit_yozma:           'Yozma In10',
    fit_etm_rtr:         'ETM RTR',
    fit_altis_sigma:     'Altis Sigma',
    fit_rawrr_mantis:    'Rawrr Mantis',
    fit_macfox:          'Macfox',
    fit_ebox:            'Ebox',
  };

  let _popupActive = false;

  /* ── helpers ── */

  function getProductData(productId) {
    const el = document.getElementById('cyb-product-data-' + productId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function getFitTag(tags) {
    return (tags || []).find(t => t.startsWith('fit_')) || null;
  }

  function getCatTag(tags) {
    return (tags || []).find(t => t.startsWith('cat_')) || null;
  }

  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function filterProducts(products, fitTag, excludeCatTag, excludeProductIds) {
    const results = [];
    for (const p of products) {
      const tags = p.tags ? (Array.isArray(p.tags) ? p.tags : p.tags.split(', ').map(t => t.trim())) : [];
      if (!tags.includes(fitTag)) continue;
      if (excludeCatTag && tags.includes(excludeCatTag)) continue;
      if (excludeProductIds.has(p.id)) continue;
      const variant = (p.variants || []).find(v => v.available);
      if (!variant) continue;
      results.push({ product: p, variant, fitTag });
    }
    return results;
  }

  async function fetchSuggestions(fitTag, excludeCatTag, excludeProductIds) {
    // Page 1
    let allProducts = [];
    try {
      const res = await fetch('/collections/all/products.json?limit=50');
      if (res.ok) {
        const { products = [] } = await res.json();
        allProducts = products;
      }
    } catch (_) {}

    let filtered = filterProducts(allProducts, fitTag, excludeCatTag, excludeProductIds);

    // Page 2 if still short
    if (filtered.length < 3) {
      try {
        const res = await fetch('/collections/all/products.json?limit=50&page=2');
        if (res.ok) {
          const { products = [] } = await res.json();
          allProducts = allProducts.concat(products);
          filtered = filterProducts(allProducts, fitTag, excludeCatTag, excludeProductIds);
        }
      } catch (_) {}
    }

    // Fallback to high-inventory bikes if still short
    if (filtered.length < 3 && fitTag !== 'fit_ultra_bee' && fitTag !== 'fit_light_bee_x') {
      for (const fallbackTag of ['fit_ultra_bee', 'fit_light_bee_x']) {
        if (filtered.length >= 3) break;
        const extra = filterProducts(allProducts, fallbackTag, excludeCatTag, excludeProductIds);
        const seen = new Set(filtered.map(f => f.product.id));
        filtered = filtered.concat(extra.filter(f => !seen.has(f.product.id)));
      }
    }

    return shuffle(filtered).slice(0, 3);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function el(tag, className, props) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (props) Object.assign(node, props);
    return node;
  }

  /* ── DOM builders ── */

  function buildCard(product, variant, fitTag) {
    const card = el('div', 'cyb-card');

    const imgSrc = product.images?.[0]?.src;
    if (imgSrc) {
      const img = el('img', 'cyb-card__img');
      img.src = imgSrc;
      img.alt = product.title;
      img.loading = 'lazy';
      card.appendChild(img);
    } else {
      card.appendChild(el('div', 'cyb-card__img cyb-card__img--placeholder'));
    }

    const info = el('div', 'cyb-card__info');
    info.appendChild(el('p', 'cyb-card__title', { textContent: product.title }));

    const bikeName = fitTag && BIKE_NAMES[fitTag];
    if (bikeName) {
      const fitBadge = el('span', 'cyb-card__fit-badge', { textContent: bikeName });
      fitBadge.style.cssText = 'display:inline-block;background:#1eff8e22;color:#085041;border:0.5px solid #1eff8e44;font-size:11px;padding:2px 8px;border-radius:20px;margin-top:3px;';
      info.appendChild(fitBadge);
    }

    info.appendChild(el('p', 'cyb-card__price', {
      textContent: formatMoney(Math.round(parseFloat(variant.price) * 100)),
    }));
    card.appendChild(info);

    const btn = el('button', 'cyb-card__btn', { type: 'button', textContent: '+ Add' });
    btn.addEventListener('click', () => handleAddFromPopup(btn, variant.id));
    card.appendChild(btn);

    return card;
  }

  function buildPopup(addedTitle, suggestions, cartCount) {
    const overlay = el('div', 'cyb-overlay');

    const popup = el('div', 'cyb-popup');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'cyb-popup-title');

    // header
    const header = el('div', 'cyb-popup__header');
    const titleSpan = el('span', 'cyb-popup__title', { id: 'cyb-popup-title', textContent: 'Complete your build' });
    const badge = el('span', 'cyb-popup__badge', { textContent: String(cartCount) });
    const closeBtn = el('button', 'cyb-popup__close', { type: 'button', textContent: '✕' });
    closeBtn.setAttribute('aria-label', 'Close popup');
    header.append(titleSpan, badge, closeBtn);

    // success bar
    const success = el('div', 'cyb-popup__success');
    success.append(
      el('span', 'cyb-popup__check', { textContent: '✓' }),
      el('span', null, { textContent: addedTitle + ' added to cart' })
    );

    // subtext
    const subtext = el('p', 'cyb-popup__subtext', {
      textContent: 'Riders who bought this also added:',
    });

    // product cards
    const products = el('div', 'cyb-popup__products');
    suggestions.forEach(({ product, variant, fitTag }) => products.appendChild(buildCard(product, variant, fitTag)));

    // cta
    const cta = el('a', 'cyb-popup__cta', { href: '/cart', textContent: 'View cart & checkout →' });

    popup.append(header, success, subtext, products, cta);

    return { overlay, popup };
  }

  /* ── cart add from popup ── */

  async function handleAddFromPopup(btn, variantId) {
    if (btn.disabled) return;
    btn.disabled = true;
    const orig = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!addRes.ok) throw new Error('add failed');

      btn.textContent = 'Added ✓';
      btn.classList.add('cyb-card__btn--added');

      // refresh cart count in the popup badge + notify theme cart system
      const cart = await fetchCart();
      const badge = document.querySelector('.cyb-popup__badge');
      if (badge) badge.textContent = String(cart.item_count);

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'complete-your-build',
          data: { source: 'complete-your-build', itemCount: 1 },
        },
      }));
    } catch (_) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  /* ── popup lifecycle ── */

  function openPopup(addedTitle, suggestions, cartCount) {
    if (_popupActive) return;
    _popupActive = true;

    const { overlay, popup } = buildPopup(addedTitle, suggestions, cartCount);
    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    // double-rAF to ensure CSS picks up initial state before transition
    requestAnimationFrame(() => requestAnimationFrame(() => {
      overlay.classList.add('cyb-overlay--visible');
      popup.classList.add('cyb-popup--visible');
    }));

    function close() {
      overlay.classList.remove('cyb-overlay--visible');
      popup.classList.remove('cyb-popup--visible');
      document.removeEventListener('keydown', onKey);
      setTimeout(() => {
        overlay.remove();
        popup.remove();
        _popupActive = false;
      }, 330);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', close);
    popup.querySelector('.cyb-popup__close').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  /* ── main listener ── */

  document.addEventListener('cart:update', async function (event) {
    const data = event.detail?.data || {};

    // only trigger on successful product-form add-to-cart
    if (data.source !== 'product-form-component' || data.didError) return;
    if (!data.productId) return;

    const productData = getProductData(data.productId);
    if (!productData) return; // not a product page, or product data missing

    const fitTag = getFitTag(productData.tags);
    if (!fitTag) return; // no fit_ tag → skip popup

    const catTag = getCatTag(productData.tags);

    let cart;
    try { cart = await fetchCart(); } catch (_) { return; }

    const cartProductIds = new Set((cart.items || []).map(i => i.product_id));
    const suggestions = await fetchSuggestions(fitTag, catTag, cartProductIds);

    if (!suggestions.length) return;

    openPopup(productData.title, suggestions, cart.item_count);
  });

})();
